<template>
  <b-modal v-model="show" size="lg"
           :title="processing ? 'Мижоз маълумотлари' : isClientPhysical ? 'Паспорт маълумотлари' : 'Юридик шахс малумотлари'"
           no-close-on-backdrop no-close-on-esc hide-header-close
           hide-footer centered>
    <div class="container-fluid">
      <div class="row" v-if="!processing && clientData">
        <div class="col-12">
          <div class="row">
            <div class="col-6">Фамилия</div>
            <div class="col-6">{{ clientData.lastname ? clientData.lastname : '' }}</div>
          </div>
        </div>

        <div class="col-12">
          <div class="row">
            <div class="col-6">Имя</div>
            <div class="col-6">{{ clientData.firstname ? clientData.firstname : '' }}</div>
          </div>
        </div>

        <div class="col-12">
          <div class="row">
            <div class="col-6">Отчество</div>
            <div class="col-6">{{ clientData.midname ? clientData.midname : '' }}</div>
          </div>
        </div>
        <template v-if="isClientPhysical">
          <div class="col-12">
            <div class="row">
              <div class="col-6">Год рождение</div>
              <div class="col-6">{{ clientData.birthDate ? clientData.birthDate : '' }}</div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">Пасспорт серия</div>
              <div class="col-6">{{ clientData.passportNumber ? clientData.passportNumber : '' }}</div>
            </div>
          </div>

          <div class="col-12" v-if="clientData && clientData.passportDate">
            <div class="row">
              <div class="col-6">Пасспорт берилган сана</div>
              <div class="col-6">{{ clientData.passportDate ? clientData.passportDate : '' }}</div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">Адрес</div>
              <div class="col-6"><span>{{ province }}, </span><span>{{ region }}, </span>{{ clientData.address ? clientData.address : '' }}</div>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="col-12">
            <div class="row">
              <div class="col-6">Должность</div>
              <div class="col-6">{{ clientData.position ? clientData.position : '' }}</div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">Ташкилот номи</div>
              <div class="col-6">{{clientData.firmName ? clientData.firmName : ''}}</div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">ИНН</div>
              <div class="col-6">{{clientData.identificationNumber ? clientData.identificationNumber: ''}}</div>
            </div>
          </div>

          <div class="col-12" v-if="!$props.hasComparative">
            <div class="row">
              <div class="col-6">Телефон ракам</div>
              <div class="col-6">{{clientData.phone}}</div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6">Ташкилот манзили</div>
              <div class="col-6">{{clientData.address ? clientData.address : ''}}</div>
            </div>
          </div>
        </template>

        <div class="col-12 mt-5">
          <div class="row">
            <div class="col-6 pr-2">
              <button class="all-btn btn-info float-right" :disabled="processing" v-if="!filterData.getNew" @click="refreshClientData">
                {{$t('action.refresh')}}
              </button>
            </div>
            <div class="col-6 pr-2" :class="{'col-12 pr-0 d-flex justify-content-center': filterData.getNew}">
              <button class="all-btn add-btn" v-if="clientData" :disabled="processing" @click="acceptClientData">
                {{$t('realEstate.action.confirm')}}
              </button>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-center mt-3 text-muted">
              <i class="fa fa-info-circle fa-lg text-info mr-1"></i> Агар малумотларда хатолик аникланса "Янгилаш"
              тугмаси босилсин
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!processing && !clientData">
        <div class="row">
          <div class="col-12 d-flex align-items-center justify-content-center py-4 text-muted"><i
              class="fa fa-lg fa-exclamation-circle pr-1" aria-hidden="true"></i>
             Мижоз маълумотлари топилмади
          </div>
        </div>
        <div class="row" v-if="!filterData.getNew">
          <div class="col-12 pr-0 d-flex justify-content-center">
            <button class="all-btn btn-info float-right" :disabled="processing" @click="refreshClientData">Янгилаш</button>
          </div>
        </div>
      </div>

    </div>
  </b-modal>
</template>

<script>
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
  export default {
    components: {
      'b-modal': bModal,
    },
    directives: {
      'b-modal': bModalDirective
    },
    props: {
      owner: {
        type: Object,
        default: null
      },
      hasComparative: {
        type: Boolean,
        default: false
      },
      processing: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        show: false,
        isClientPhysical: false,
        clientData: null,
        filterData: {
          getNew: false
        }
      }
    },
    computed: {
      province() {
        return this.clientData && this.clientData.region
        && this.clientData.region.province
        && this.clientData.region.province.name
            ? this.clientData.region.province.name : ''
      },
      region() {
        return this.clientData && this.clientData.region
        && this.clientData.region.name
            ? this.clientData.region.name : ''
      }
    },
    methods: {
      refreshClientData() {
        this.filterData.getNew = true
        this.$emit("handle-refresh")
      },
      acceptClientData() {
        this.$emit("handle-accept")
        this.show = false
      }
    },
    created() {
      this.$eventBus.$on('showClientDataModal', () => {
        this.show = true;
      })
    },
    beforeDestroy() {
      this.$eventBus.$off('showClientDataModal')
    },
    watch: {
      owner: {
        immediate: true,
        handler() {
          this.clientData = this.owner
          if (this.owner && this.owner.clientType === 'Physical') {
            this.isClientPhysical = true;
          }
          console.log('owner = ',this.owner)
        }
      }
    }
  }
</script>

<style scoped>

</style>